export default "__VITE_ASSET__Cvp50iku__"